import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { FormattedMessage } from 'react-intl';

export interface DelinquencyLegendProps {
    isLoading?: boolean;
}

const Legend = ({ isLoading = false }: DelinquencyLegendProps) => {
    const { theme } = useTheme();
    return (
        <Box component="span" display="flex" justifyContent="end">
            <Typography component="span" variant="body2">
                {isLoading ? (
                    <Skeleton data-testid="paid-skeleton" />
                ) : (
                    <Box
                        component="span"
                        data-testid="paid-legend-dot"
                        sx={{
                            '&::before': {
                                content: '"•"',
                                color: theme.palette.success.dark,
                                fontSize: theme.typography.h5.fontSize,
                                marginRight: theme.spacing(0.266),
                            },
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                        <FormattedMessage
                            id="DelinquencyLegend.paid"
                            defaultMessage="Paid"
                        />
                    </Box>
                )}
            </Typography>
            <Typography component="span" variant="body2" marginLeft={4}>
                {isLoading ? (
                    <Skeleton data-testid="overdue-skeleton" />
                ) : (
                    <Box
                        component="span"
                        data-testid="overdue-legend-dot"
                        sx={{
                            '&::before': {
                                content: '"•"',
                                color: theme.palette.error.dark,
                                fontSize: theme.typography.h5.fontSize,
                                marginRight: theme.spacing(0.266),
                            },
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}>
                        <FormattedMessage
                            id="DelinquencyLegend.overdue"
                            defaultMessage="Overdue"
                        />
                    </Box>
                )}
            </Typography>
        </Box>
    );
};

export default Legend;
